module.exports = __webpack_public_path__ + "img/partial_day_icon.f21a8ec4.png";